import React from 'react';
// styles
import styled from 'styled-components';

const collapseIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Collapse"
    className={className}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_2549_35430)">
      <path
        d="M11.7509 23.7392C12.0632 23.5212 12.2764 23.1883 12.3439 22.8135C12.4113 22.4387 12.3276 22.0524 12.1109 21.7392L5.5279 12.2722C5.47176 12.1917 5.44167 12.0958 5.44167 11.9977C5.44167 11.8995 5.47176 11.8037 5.5279 11.7232L12.1109 2.26018C12.2188 2.10489 12.2952 1.92987 12.3355 1.74509C12.3758 1.56031 12.3793 1.36941 12.3458 1.18327C12.3123 0.997135 12.2425 0.819416 12.1404 0.660261C12.0382 0.501105 11.9057 0.363629 11.7504 0.255682C11.5951 0.147736 11.4201 0.0714325 11.2353 0.0311291C11.0505 -0.0091744 10.8596 -0.0126887 10.6735 0.0207868C10.4874 0.0542624 10.3096 0.124072 10.1505 0.22623C9.99133 0.328388 9.85385 0.460894 9.7459 0.616182L3.1639 10.0792C2.77388 10.6429 2.56494 11.3122 2.56494 11.9977C2.56494 12.6832 2.77388 13.3524 3.1639 13.9162L9.7459 23.3792C9.85388 23.5345 9.9914 23.667 10.1506 23.7692C10.3098 23.8714 10.4876 23.9412 10.6738 23.9746C10.86 24.008 11.051 24.0045 11.2358 23.9641C11.4206 23.9237 11.5956 23.8472 11.7509 23.7392Z"
        fill="white"
      />
      <path
        d="M16.4731 0.889539L9.88905 10.3525C9.55494 10.8359 9.37598 11.4095 9.37598 11.997C9.37598 12.5846 9.55494 13.1582 9.88905 13.6415L16.4731 23.1055C16.5616 23.2324 16.6795 23.336 16.8167 23.4076C16.9539 23.4792 17.1063 23.5165 17.2611 23.5165H20.4741C20.6494 23.5165 20.8214 23.4684 20.9713 23.3776C21.1213 23.2867 21.2435 23.1565 21.3247 23.0011C21.4059 22.8457 21.443 22.6711 21.4319 22.4961C21.4209 22.3211 21.3621 22.1525 21.2621 22.0085L14.6791 12.5455C14.567 12.384 14.507 12.1921 14.507 11.9955C14.507 11.799 14.567 11.6071 14.6791 11.4455L21.2621 1.98154C21.361 1.83761 21.4189 1.6694 21.4293 1.49503C21.4398 1.32066 21.4025 1.14674 21.3214 0.992003C21.2403 0.83727 21.1186 0.707591 20.9693 0.616934C20.82 0.526278 20.6487 0.478082 20.4741 0.477539H17.2611C17.1062 0.477575 16.9537 0.515062 16.8165 0.586803C16.6793 0.658544 16.5614 0.762409 16.4731 0.889539Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2549_35430">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default styled(collapseIcon)``;
